import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ParametroAccionService {
  public parametro: string;
  public datos: any;

  constructor() { }

  guardarParam(parametro: string): void {
    this.parametro = parametro;
  }

  obtenerParam(): string {
    return this.parametro;
  }

  guardarDatos(datos: any): void {
    this.datos = datos;
  }

  obtenerDatos(): any {
    return this.datos;
  }

  limpiarDatos(): void {
    this.parametro = '';
    this.datos = '';
  }
}
